<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card class="elevation-12">
          <v-card-title>
            Deleted Todos
            <v-spacer />

            <v-dialog v-model="dialog" width="300">
              <template v-slot:activator="{ on }">
                <v-btn class="error" v-on="on" :disabled="!deletedTodos.length"
                  >Clear</v-btn
                >
              </template>
              <v-card>
                <v-card-title> Are you sure? </v-card-title>
                <v-card-text>
                  This action will clear all of your deleted todos! (This can't
                  be undone)
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn @click="clear" color="error" outlined>Yes</v-btn>
                  <v-btn @click="dialog = false" color="success" text>No</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-title>
          <v-card-subtitle> :( sad todos </v-card-subtitle>
          <v-card-text>
            <v-divider />
            <v-list v-if="deletedTodos.length">
              <div :key="todo.id" v-for="todo in deletedTodos">
                <v-list-item>
                  <v-list-item-action>
                    <v-btn icon color="green" @click="restore(todo.id)"
                      ><v-icon>mdi-restore</v-icon></v-btn
                    >
                  </v-list-item-action>
                  <v-list-item-content>
                    <span class="todo-text body-1">{{ todo.text }}</span>
                  </v-list-item-content>
                  <v-list-item-action> </v-list-item-action>
                </v-list-item>
                <v-divider />
              </div>
            </v-list>
            <v-col v-else>
              <p class="body-1 text-center mt-5 mb-5">
                You took out the trash!
              </p>

              <v-img
                :src="
                  $vuetify.theme.dark
                    ? require('../assets/images/deleted-tasks-light.svg')
                    : require('../assets/images/deleted-tasks-dark.svg')
                "
                alt="Empty todo list!"
                width="200px"
                class="mx-auto my-5"
              ></v-img>
              <v-divider />
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Deleted',
  components: {},
  computed: {
    ...mapGetters(['deletedTodos']),
  },
  methods: {
    clear() {
      this.dialog = false
      this.$store.dispatch('clearDeleted')
    },
    restore(id) {
      this.$store.dispatch('editTodo', {
        id,
        key: 'deleted',
        value: false,
      })
    },
  },
  data: () => ({
    dialog: false,
  }),
}
</script>

<style></style>
